import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Self } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { ReplaySubject, Subscription } from 'rxjs';

@Component({
  selector: 'eiq-input-action',
  templateUrl: './input-action.component.html',
  styleUrls: ['./input-action.component.scss', '_input-action-theme.component.scss']
})
export class InputActionComponent implements OnInit, OnDestroy {
  @Input() actionText: string;
  @Input() hint: string;
  @Input() icon: IconDefinition;
  @Input() label: string;
  @Input() type: 'text' = 'text';
  @Input() placeholder: string;

  @Output() keyupEnter = new EventEmitter<void>();
  @Output() clicked = new EventEmitter<void>();

  onChange: (value: string) => void;
  onTouched: () => void;

  control: FormControl;
  currentValue: string;

  private input$ = new ReplaySubject(1);
  private subscriptions: Subscription[] = [];

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.control = this.ngControl.control as FormControl;
    this.subscriptions.push(
      this.input$.subscribe((input: string) => {
        this.onChange(input);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(input: string): void {
    this.currentValue = input ?? '';
  }

  setValue($event: any): void {
    this.currentValue = $event.target.value;
    this.input$.next($event.target.value);
  }

  clearValue(): void {
    this.currentValue = '';
    this.input$.next('');
  }
}
